import { userAgentParser } from '@common/UserAgentParser/UserAgentParser'

/**
 * Safarit használ a user.
 * @param ua - UserAgent.
 */
export default function isSafari (ua: string): boolean {
  return userAgentParser.isSafari(ua)
}
